<template>
  <div class="marker m-3 shadow round border">
    <div class="d-flex flex-column justify-content-start p-3">
      <div class="row w-100 mx-2">
        <div class="col-12">
          <h4 class="text-logo font-weight-bold m-0">{{ word }}.</h4>
        </div>
      </div>
      <div
        class="row w-100 mx-2"
        v-for="(def, index) of word_data.definitions"
        :key="index"
      >
        <div class="col-12">
          <h5 class="m-0 font-weight-bold">
            {{ index + 1 }}. {{ def.definition }}
          </h5>
        </div>
        <div
          class="col-12 ml-3 d-flex flex-row justify-content-end"
          v-if="def.example"
        >
          <span class="p-3"><b>Ej.: </b>{{ def.example }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "br-word",
  props: {
    word_data: {},
  },
  computed: {
    word: function() {
      return `${this.word_data.word} ${
        this.word_data.meaning ? "/ " + this.word_data.meaning : ""
      }`;
    },
  },
};
</script>
<style lang="css"></style>
